"use client";
import styles from "./HamburgerComponent.module.css";
import { multipleClassName } from "../../../utils/helpers";
import { useDownloadContext } from "../../../contexts/CommonContext";

const HamburgerComponent = () => {
    const { menuOpen, handleHamburgerClick } = useDownloadContext();
    return handleHamburgerClick ? (
        <div
            onClick={() => handleHamburgerClick()}
            className={
                menuOpen
                    ? multipleClassName(styles.hamburgerContainer, styles.open)
                    : styles.hamburgerContainer
            }
        >
            <span />
            <span />
            <span />
            <span />
        </div>
    ) : (
        <></>
    );
};

export default HamburgerComponent;
